import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Drives from "./Drives";
import { forbidExtraProps } from "utils";

import {
  toggleSourceType,
  toggleSourceDevice,
  toggleSourceVolume
} from "store/actions";
import { objectToArray } from "utils";

function Source(props) {
  return (
    <div className="main_summary_source">
      <div className="mss_radios">
        {objectToArray(props.volumes.sourceType.list).map((val, i) => (
          <div className="mss_radios_item" key={val.key}>
            <label className="radio_container">
              <input
                type="radio"
                className="input_radio"
                name="radio_source"
                id="source_entire_pc"
                checked={props.volumes.sourceType.current === val.key}
                onChange={() => props.toggleSourceType(val.key)}
                tabIndex={0}
              />
              <span className="radio_checkmark" />
              <span className="fs_16">{val.name}</span>
            </label>
          </div>
        ))}
      </div>

      <div
        className={[
          "mss_source_drives",
          "transparent_layer_wrap",
          "transparent_layer_summary",
          props.volumes.sourceType.current === "customize"
            ? "layer_active"
            : null
        ].join(" ")}
      >
        <div className="transparent_layer" />

        <Drives
          list={props.volumes.list}
          toggleSourceDevice={props.toggleSourceDevice}
        />
      </div>
    </div>
  );
}

Source.propTypes = forbidExtraProps(
  {
    volumes: PropTypes.shape({
      sourceType: PropTypes.object.isRequired,
      list: PropTypes.object.isRequired
    }).isRequired
  },
  ["toggleSourceType", "toggleSourceDevice", "toggleSourceVolume"]
);

function mapStateToProps(state) {
  return {
    volumes: state.backupSettings.volumes
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleSourceType,
      toggleSourceDevice,
      toggleSourceVolume
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Source);
